import {
  insertStr,
  compareCabin,
  getPhysicalCabinName,
} from '@csair/emp-helpers';
import {
  FIND_FLIGHT_LIST,
  SELECT_FLIGHT,
  CLEAR_FLIGHT,
  REST_FLIGHT,
  SAVE_WQT_OBJ,
  INIT_FLIGHT,
} from './actions';
import { cabinSort } from 'Utils';

const initialState = {
  // 湾区通
  bayArea: {
    // NORMAL 普通变更，默认
    // WQT_KX 湾区通快线
    // WQT_YDHC 湾区通异地换乘
    // WQT_NHKX 南航快线
    // WQT_NCKX 南川快线
    bayAreaType: 'NORMAL',
    message: '',
    discount: 1,
    segmentOptions: [],
    startDate: '',
    endDate: '',
  },
  list: [], // 列表数据
  _list: [], // 新航班接口返参
  wqtObj: {}, // key: 航班号, value: { oldFlight, bayAreaType, startDate, endDate }
  taxs: {}, // 税费
  exchangeMode: '', // 换开方式 1自动，其他都是人工，其中0为客服人工，2为销售单位，3为代理人，4紧急换开
  ticketChannel: '', // 出票渠道（客票类型）
  selectFlight: [], // 选择的新航班数据
  artificialFlag: [], // 选择的新航班是否走人工的标识，0 不走人工，1走人工
  selectNum: [], // 选择的新航班为正常情况true，若处于重选状态，按选择序列，修改为false，当所有元素为true时标识选择完毕
  bayAreaTransferDto: {}, //不等于NORMAL就是中转快线
};

export default function ticketChangesReducer(state = initialState, action) {
  switch (action.type) {
    case INIT_FLIGHT:
      return initialState;
    case `${FIND_FLIGHT_LIST}_SUCCESS`:
      const {
        payload: { data },
      } = action;
      if (!data.errorInfo) {
        // 初始化赋予湾区通数据，可能一进来当前的航班已经是属于弯曲通的
        const wqtObj = state.wqtObj || {};
        const flightNo = JSON.parse(action.payload.config.data).flightNo;
        const bayArea = data.bayArea || {};
        let dataArr = JSON.parse(JSON.stringify(data.list))
        // 合并湾区通数据对象，作用于日期范围限制退回旧航班数据，旧航班数据可能不存在，因为没有更换行程
        wqtObj[flightNo] = Object.assign({}, wqtObj[flightNo], {
          bayAreaType: bayArea.bayAreaType,
          discount: bayArea.discount,
          endDate: bayArea.endDate,
          startDate: bayArea.startDate,
        });
        return Object.assign({}, state, {
          list: data.list.map(item => {
            item.crowdInfo = data.crowdInfo;
            item.tagInfo = data.tagInfo;
            if (item.departTime.indexOf(':') === -1)
              item.departTime = insertStr(item.departTime, 2, ':');
            if (item.arriveTime.indexOf(':') === -1)
              item.arriveTime = insertStr(item.arriveTime, 2, ':');
            if (!item.cabinLists) return item;
            item.cabinListsCopy = JSON.parse(JSON.stringify(item.cabinLists))
            const keys = Object.keys(item.cabinLists);
            let cabinObj = {};
            keys.forEach((child, ind) => {
              let arr;
              if (!(action.meta.previousAction.originFlight.carrier === "MU"
                || action.meta.previousAction.originFlight.carrier === "CA"
                || action.meta.previousAction.originFlight.carrier === "HU")) {
                item.cabinLists[child] = cabinSort(item.cabinLists[child]);
              }
              if (action.meta.previousAction.originFlight.carrier === "CA") {
                item.cabinLists[child] = item.cabinLists[child].sort((p, l) => {
                  return l[Object.keys(l)[0]][0].changeFare - p[Object.keys(p)[0]][0].changeFare
                })[0][Object.keys(item.cabinLists[child].sort((p, l) => {
                  return l[Object.keys(l)[0]][0].changeFare - p[Object.keys(p)[0]][0].changeFare
                })[0])[0]]
              }
              let isPriorityFlight = item.cabinLists[child].some(
                flight => flight.isPriorityDisplay
              );
              arr = isPriorityFlight
                ? item.cabinLists[child].filter(i => {
                  return i.isPriorityDisplay;
                })
                : item.cabinLists[child].filter(i => {
                  return (
                    compareCabin(
                      action.meta.previousAction.originFlight.flightCabin,
                      i.cabin
                    ) === -1 ||
                    compareCabin(
                      action.meta.previousAction.originFlight.flightCabin,
                      i.cabin
                    ) === 0
                  );
                });

              let cabinArr = [];
              if (arr.length !== 0) {
                let otherCabin = {}, sortedObj2 = {};
                arr.forEach((v, index) => {
                  if (ind == 0) {
                    if (!cabinObj[v.cabinName]) {
                      cabinObj[v.cabinName] = JSON.parse(JSON.stringify(v));
                      cabinObj[v.cabinName].index = index
                    }
                    if (v.addAmount < cabinObj[v.cabinName].addAmount) {
                      cabinObj[v.cabinName] = JSON.parse(JSON.stringify(v));
                      cabinObj[v.cabinName].index = index
                    }
                    // if (action.meta.previousAction.originFlight.carrier === "MU" && v.addAmount === cabinObj[v.cabinName].addAmount) {
                    //   cabinObj[v.cabinName] = JSON.parse(JSON.stringify(v));
                    //   cabinObj[v.cabinName].index = key
                    // }
                  } else {
                    for (let jkl in cabinObj) {
                      if (action.meta.previousAction.originFlight.carrier === "MU"
                        || action.meta.previousAction.originFlight.carrier === "CA"
                        || action.meta.previousAction.originFlight.carrier === "HU"
                      ) {
                        if (cabinObj[jkl].index === index) {
                          otherCabin[jkl] = v;
                        }
                      } else {
                        if (cabinObj[jkl].cabin == v.cabin) {
                          otherCabin[jkl] = v;
                        }
                      }
                    }

                    if (action.meta.previousAction.originFlight.carrier === "MU"
                      || action.meta.previousAction.originFlight.carrier === "CA"
                      || action.meta.previousAction.originFlight.carrier === "HU"
                    ) {
                      Object.keys(cabinObj).forEach(key => {
                        sortedObj2[key] = otherCabin[key]; // 直接赋值，保持原有值和顺序
                      })
                    } else {
                      sortedObj2 = otherCabin;
                    }
                  }
                });

                if (ind == 0) {
                  for (var key in cabinObj) {
                    cabinObj[key]._firstFlight = 'Y';
                    cabinArr.push(cabinObj[key]);
                    if (
                      getPhysicalCabinName(
                        action.meta.previousAction.originFlight.flightCabin
                      ) !== getPhysicalCabinName(cabinObj[key].cabin)
                    ) {
                      cabinObj[key]._changeStyle = 'Y';
                    }
                  }
                } else {
                  for (var key in sortedObj2) {
                    sortedObj2[key]._firstFlight = 'Y';
                    cabinArr.push(sortedObj2[key]);
                    if (
                      getPhysicalCabinName(
                        action.meta.previousAction.originFlight.flightCabin
                      ) !== getPhysicalCabinName(sortedObj2[key].cabin)
                    ) {
                      sortedObj2[key]._changeStyle = 'Y';
                    }
                  }
                }
              }

              //  新双城套票不展示智能推荐
              if (!data.yTwinCity) {
                item.cabinLists[child] = cabinArr.concat(
                  item.cabinLists[child]
                );
              }
            });
            return item;
          }),
          bayArea: bayArea,
          wqtObj: wqtObj,
          taxs: data.taxs || {},
          yTwinCity: data.yTwinCity || false,
          bayAreaTransferDto:
            state.bayAreaTransferDto &&
              Object.keys(state.bayAreaTransferDto).length !== 0
              ? state.bayAreaTransferDto
              : data.bayAreaTransferDto || {},

        });
      }
      return Object.assign({}, state, {
        list: [],
      });
    case SELECT_FLIGHT:
      if (action.key !== '') {
        const arr = [...state.selectFlight];
        arr.splice(action.key, 1, action.data);
        const arrFlag = [...state.artificialFlag];
        arrFlag.splice(action.key, 1, action.flag);
        const arrSelect = [...state.selectNum];
        arrSelect[action.key] = true;
        return Object.assign({}, state, {
          list: [],
          selectFlight: arr,
          artificialFlag: arrFlag,
          selectNum: arrSelect,
        });
      } else {
        return Object.assign({}, state, {
          list: [],
          selectFlight: [...state.selectFlight, action.data],
          artificialFlag: [...state.artificialFlag, action.flag],
          selectNum: [...state.selectNum, true],
        });
      }
    case CLEAR_FLIGHT:
      if (action.key !== '') {
        const arr = [...state.selectFlight];

        arr.splice(action.key, 1, {});
        return Object.assign({}, state, { selectFlight: arr });
      } else {
        return Object.assign({}, state, {
          selectFlight: [],
          artificialFlag: [...state.artificialFlag],
          selectNum: [],
        });
      }
    case REST_FLIGHT:
      const arr = [...state.selectNum];
      arr[action.key] = false;
      return Object.assign({}, state, { selectNum: arr });
    case SAVE_WQT_OBJ:
      return Object.assign({}, state, { wqtObj: action.wqtObj });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/routes/routes/ticketChanges/modules/ticketChanges.js